import { Message as MessageI } from "@moe/priv/model/message";
import { CharacterMessage } from "@web/route-services/chat/message/CharacterMessage";
import { UserMessage } from "@web/route-services/chat/message/UserMessage";
import { forwardRef, memo } from "react";

export interface MessageProps {
  message: MessageI;
  isTop: boolean;
  isBottom: boolean;
  className?: string;
}

export const Message = memo(
  forwardRef<HTMLDivElement, MessageProps>(({ message, isTop, isBottom, className }, ref) => {
    if (Array.isArray(message)) {
      return <CharacterMessage ref={ref} message={message} isTop={isTop} isBottom={isBottom} className={className} />;
    }
    return <UserMessage ref={ref} message={message} isBottom={isBottom} className={className} />;
  })
);

export const baseMessageStyles = `h-fit flex items-start space-x-4 px-3.5 pb-3  md:pl-6 md:pr-8 md:pb-5
  font-base hover:brightness-105  transition
  md:duration-300  duration-500 ease-out md:ease-out rounded-xl group/msg`;
export const baseMessageEditStyles = "outline-[2px] outline-dashed outline-tx-tertiary";
